import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ValidacionMateriaPrima/imprimirValidacionMateriaPrima`, method: 'POST', body: values, token: token})
}